/**
 * @file PhosphorusListView.jsx
 * @author Daniel Aguirre
 * @description Phosphorus List View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

// Helpers
import {
  joinArrayObject,
  removeNullValuesFromObject
} from 'commons/helpers/utils';
import {
  createColumns,
  getSearchApiKeys,
  getSorterString,
  PAGE_LIMIT
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function PhosphorusListView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const { classification, totalItems: totalItemsParams } = useParams();
  const [totalItems, setTotalItems] = React.useState(totalItemsParams);
  const [dataFilter, setDataFilter] = React.useState(null);
  const [columns, setColumns] = React.useState([]);
  const [filter, setFilter] = React.useState(null);
  const [sorter, setSorter] = React.useState(null);

  const { getPhosphorusListPlus } = dashboardStaffActions;

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const joinFilter = joinArrayObject(filter);
    const joinSorter = joinArrayObject(sorter);
    const data = {
      params: {
        idClinic: clinicId,
        controlSeleccionado: classification,
        limit: pageSize,
        offset,
        ...joinFilter,
        ...joinSorter
      }
    };
    getPhosphorusListPlus(data, (_, resp) => {
      if (resp?.data && resp.data?.totalRegistros != null) {
        setTotalItems(resp.data?.totalRegistros);
        setRowData(resp.data?.listaDetalles ?? []);
        setDataFilter(resp.data);
      }
    });
  };

  const handleTableChange = (pagination, filters, sorterFilter) => {
    if (filters || sorterFilter) {
      const convertedFilters = getSearchApiKeys(
        columns,
        removeNullValuesFromObject(filters)
      );
      const convertedSorts = getSorterString(sorterFilter);
      setFilter(convertedFilters);
      setSorter(convertedSorts);
    }
  };

  React.useEffect(() => {
    if (clinicId !== null) getetData(1);
  }, [clinicId]);

  React.useEffect(() => {
    const cols = createColumns(translate, dataFilter);
    setColumns(cols);
  }, [rowData, dataFilter]);

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      onPaginationChange={getetData}
      onChange={handleTableChange}
      filter={filter}
      sorter={sorter}
    />
  );
}

/**
 * Component definition of proptypes.
 */
PhosphorusListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPhosphorusListPlus: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PhosphorusListView;
